var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[_c('router-view')],1),_c('portal-target',{attrs:{"name":"mask","multiple":""}}),_c('portal-target',{attrs:{"name":"maskUpload"}}),_c('portal-target',{attrs:{"name":"maskDefaultFirmware"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }